// stores/localeStore.js
// Locale Store - Language and Currency Management
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

const LOCALE_STORAGE_KEY = "st_cael_locale";

export const useLocaleStore = create(
  persist(
    (set, get) => ({
      // Language: 'fr' (French) by default, 'en' (English) as option
      language: 'fr',
      
      // Currency: 'USD' by default, 'CDF' (Congolese Franc) as option
      currency: 'USD',
      
      // Exchange rate: 1 USD = ~2000 CDF (approximate, should be updated from API)
      exchangeRate: 2000,
      
      // Set language
      setLanguage: (lang) => {
        if (lang === 'fr' || lang === 'en') {
          set({ language: lang });
        }
      },
      
      // Set currency
      setCurrency: (curr) => {
        if (curr === 'USD' || curr === 'CDF') {
          set({ currency: curr });
        }
      },
      
      // Set exchange rate
      setExchangeRate: (rate) => {
        if (typeof rate === 'number' && rate > 0) {
          set({ exchangeRate: rate });
        }
      },
      
      // Convert price based on currency
      convertPrice: (priceInUSD) => {
        const { currency, exchangeRate } = get();
        if (currency === 'CDF') {
          return priceInUSD * exchangeRate;
        }
        return priceInUSD;
      },
      
      // Get currency symbol
      getCurrencySymbol: () => {
        const { currency } = get();
        return currency === 'CDF' ? 'FC' : '$';
      },
      
      // Get currency code
      getCurrencyCode: () => {
        return get().currency;
      },
    }),
    {
      name: LOCALE_STORAGE_KEY,
      storage: createJSONStorage(() => localStorage),
    }
  )
);

